import Box from '@mui/material/Box';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useTranslation } from 'react-i18next';
import ScrollToTop from './components/ScrollToTop';
import Alert from './components/alert';
import { BaseOptionChartStyle } from './components/chart/BaseOptionChart';
import { useGAPageTracking } from './hooks/useGAPageTracking';
import { useOnlineActivityTracking } from './hooks/useOnlineActivityTracking';
import { dateLocales } from './locales/i18n';
import Router from './routes';
import ThemeProvider from './theme';

// ----------------------------------------------------------------------

export default function App() {
  const { i18n } = useTranslation();

  useGAPageTracking();
  useOnlineActivityTracking();

  return (
    <Box>
      <LocalizationProvider
        dateAdapter={AdapterDateFns}
        adapterLocale={dateLocales[i18n.language || window.localStorage.i18nextLng || 'en']}
      >
        <ThemeProvider>
          <ScrollToTop />
          <BaseOptionChartStyle />
          <Router />
          <Alert />
        </ThemeProvider>
      </LocalizationProvider>
    </Box>
  );
}
